<template>
  <Navbar />
  <div class="main-layout">
    <Sidebar />
    <div class="main-content">
      <router-view />
    </div>
  </div>
</template>

<script setup>
import Navbar from './Navbar.vue'
import Sidebar from './Sidebar.vue'
</script>

<style scoped>
.main-layout {
  display: flex;
  flex-direction: row;
  min-height: calc(100vh - 70px);
}
.main-content {
  flex: 1;
  min-height: calc(100vh - 70px);
  display: flex;
  flex-direction: column;
  padding: 0;
  background: #f5f7fa;
}
</style> 